interface GuideTabsProps {
  activeTab: "pre-order" | "live-order";
  onTabChange: (tab: "pre-order" | "live-order") => void;
}

const GuideTabs: React.FC<GuideTabsProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="flex pt-4 px-4 bg-white border-b border-gray-200">
      <div className="flex">
        <div
          className={`pb-3 px-6 cursor-pointer ${
            activeTab === "pre-order"
              ? "text-black font-bold border-b-2 border-green-500"
              : "text-gray-400"
          }`}
          onClick={() => onTabChange("pre-order")}
        >
          예약팩
        </div>
        <div
          className={`pb-3 px-6 cursor-pointer ${
            activeTab === "live-order"
              ? "text-black font-bold border-b-2 border-blue-500"
              : "text-gray-400"
          }`}
          onClick={() => onTabChange("live-order")}
        >
          실시간팩
        </div>
      </div>
    </div>
  );
};

export default GuideTabs;
